
const AudioIcon = () => (
  <svg width="28" height="28" viewBox="0 0 28 28" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M0 8C0 3.58172 3.58172 0 8 0H20C24.4183 0 28 3.58172 28 8V20C28 24.4183 24.4183 28 20 28H8C3.58172 28 0 24.4183 0 20V8Z" fill="#1E90FF" />
    <path d="M9 12.2168V15.7918" stroke="white" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
    <path d="M11.5 11.0254V16.9754" stroke="white" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
    <path d="M14 9.8335V18.1668" stroke="white" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
    <path d="M16.5 11.0254V16.9754" stroke="white" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
    <path d="M19 12.2168V15.7918" stroke="white" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
    <path d="M11.5 22.3332H16.5C20.6666 22.3332 22.3333 20.6665 22.3333 16.4998V11.4998C22.3333 7.33317 20.6666 5.6665 16.5 5.6665H11.5C7.33329 5.6665 5.66663 7.33317 5.66663 11.4998V16.4998C5.66663 20.6665 7.33329 22.3332 11.5 22.3332Z" stroke="white" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
  </svg>
)

export default AudioIcon
